import Loading from './Loading';

// Spinner de botón: tramo largo blanco y tramo corto transparente (toma el color del botón).
// light: para botones de fondo claro, el tramo largo usa el color personalizado.
const ButtonLoadingContent = ({
  loading,
  children,
  size = '4',
  light = false,
}) => (
  <span className="relative inline-flex min-w-0 items-center justify-center gap-[inherit]">
    <span className={`inline-flex items-center justify-center gap-[inherit] whitespace-nowrap${loading ? ' invisible' : ''}`}>{children}</span>
    {loading && (
      <span className={`button-loading-spinner${light ? ' button-loading-spinner-light' : ''} absolute inset-0 flex items-center justify-center`}>
        <Loading
          size={size}
          colorBase={light ? 'personalized' : 'white'}
          colorAccent="transparent"
          inline
        />
      </span>
    )}
  </span>
);

export default ButtonLoadingContent;
